import React from 'react';
import brand1 from '../static/images/brands/brand1.png';
import brand2 from '../static/images/brands/brand2.png';

export default function PartnerBrands() {
  return (
    <div className='
        w-full px-8
        lg:w-[1000px]
        h-48
        overflow-x-auto
        flex items-center justify-center gap-8
        '>
      <img src={brand1} alt="Brand 1" className='w-48 object-contain' />
      <img src={brand2} alt="Brand 2" className='w-48 object-contain' />
    </div>
  )
}
